import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { ServiceShiftAssignment } from '@wilson/interfaces';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class AssignmentService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  async assignActivity(assignment: ServiceShiftAssignment) {
    return firstValueFrom(
      this.httpClient.post<ServiceShiftAssignment[]>(
        `${this.config.host}/shifts/activities/assign`,
        assignment,
      ),
    );
  }
}
